import type { IHTTPConversation, InternalChatConversation } from 'packages/workspace/services/models/internal-channel';
import { InternalConversationStore } from 'packages/workspace/services/store/omnichannel/internal-conversation-store';
import useSession from 'packages/workspace/services/store/session-store';
import { UseQueryResult, useQuery } from 'react-query';
import type { ResponseFormat } from './../../../services/models/global-models';

import { Http } from './../../prelude/http/index';

export const fetchInternalChannels = async (): Promise<Array<InternalChatConversation>> =>
  await Http.Request<ResponseFormat<Array<InternalChatConversation>>>('GET', '/workspaces/api/v1/internal-channels.list').then((res) => res.data);

export default function useInternalChatChannels(): UseQueryResult<Array<InternalChatConversation>> {
  const session = useSession();
  return useQuery(['channels'], fetchInternalChannels, {
    onSettled: (data = []) => {
      InternalConversationStore.updateActiveConversations(data, session.iamPrincipal.id);
    },
  });
}
/**
 *!Fetch Channel Conversation
 */
export const fetchConversation = async (conversation_id: string): Promise<IHTTPConversation> =>
  (await Http.Request)<ResponseFormat<IHTTPConversation>>('GET', `/workspaces/api/v1/internal-conversations.get?conversation_id=${conversation_id}`).then((res) => res.data);

export function useFetchChannelConversation(conversation_id: string): UseQueryResult<IHTTPConversation> {
  return useQuery(['channels', conversation_id], () => fetchConversation(conversation_id), {
    staleTime: Number.POSITIVE_INFINITY,
    enabled: conversation_id !== '',
    onSettled: (data) => {
      if (data) InternalConversationStore.updateBulkMessages(conversation_id, data.messages);
    },
  });
}
